module.exports = __webpack_public_path__ + "assets/img/p2.e3bd7a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p2.jpg
// module id = 583
// module chunks = 1